import Environment from '../Environment';

class ServiceUrl {
  static public(service) {
    const { REACT_APP_SERVICE_LOCATOR_OVERRIDE, REACT_APP_CLOUD_NATIVE_DNS_BASE } = process.env;
    if (REACT_APP_SERVICE_LOCATOR_OVERRIDE) {
      console.log(`OVERRIDING EXTERNAL SERVICES TO POINT TO ${REACT_APP_SERVICE_LOCATOR_OVERRIDE}`); // eslint-disable-line no-console
      return REACT_APP_SERVICE_LOCATOR_OVERRIDE.replace('{{SERVICE}}', service);
    }

    const publicDns = Environment.publicDns();

    switch (service) {
      case 'noths':
        return `https://www.${publicDns}`;
      case 'communication-preferences':
        return `https://${service}.${REACT_APP_CLOUD_NATIVE_DNS_BASE}`;
      default:
        return `https://${service}.${publicDns}`;
    }
  }
}

export default ServiceUrl;
